module.exports = __webpack_public_path__ + "static/media/step3a.5e228f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step3a.png
// module id = 3737
// module chunks = 0